import { Controller, useForm } from 'react-hook-form';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

import { Client } from '@c/client';

import { AddClientGroupForm } from '@t/user/components/clientGroupFilter/field-values.schema';

const ClientGroupBody = () => {
  const { control, register } = useForm<AddClientGroupForm>();
  const { ref: nameRef, ...name } = register('name');
  const { ref: descriptionRef, ...description } = register('description');

  return (
    <FormGroup row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>Name</Label>
        </Col>
        <Col>
          <Input
            {...name}
            innerRef={nameRef}
            type="text"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>Description</Label>
        </Col>
        <Col>
          <Input
            {...description}
            innerRef={descriptionRef}
            type="text"
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>Clients</Label>
        </Col>
        <Col>
          <Controller
            control={control}
            name="clients"
            render={({ field: { onChange, value } }) => (
              <Client
                onSelected={(controlValue) => onChange(controlValue)}
                placeholder="Select Clients"
                selected={value}
              />
            )}
          />
        </Col>
      </Row>
    </FormGroup>
  );
};

export default ClientGroupBody;
